// The require scope
var __webpack_require__ = {};

// webpack/runtime/define_property_getters
(() => {
__webpack_require__.d = (exports, definition) => {
	for(var key in definition) {
        if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
        }
    }
};
})();
// webpack/runtime/has_own_property
(() => {
__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
})();
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  mI: () => (/* reexport */ FuncionalidadesMap),
  Fp: () => (/* reexport */ security_Perfil),
  Ud: () => (/* reexport */ security_Permissao),
  l6: () => (/* reexport */ Rbac),
  Ru: () => (/* reexport */ security_TipoUsuario),
  b5: () => (/* reexport */ security_TipoVinculo),
  DL: () => (/* reexport */ FuncionalidadesMap_Funcionalidade)
});

;// CONCATENATED MODULE: ./src/security/Permissao.ts
const Permissao = {
    // Módulo
    CONSOLE: 'CONSOLE_CONSOLE',
    // Páginas
    CREDENCIAIS: 'CONSOLE_CREDENCIAIS',
    MODULOS: 'CONSOLE_MODULOS',
    PARCEIROS: 'CONSOLE_PARCEIROS'
};
/* export default */ const security_Permissao = (Permissao);

;// CONCATENATED MODULE: ./src/security/TipoVinculo.ts
var TipoVinculo_TipoVinculo = /*#__PURE__*/ function(TipoVinculo) {
    TipoVinculo["ADMIN"] = "G";
    TipoVinculo["MUNICIPIO"] = "M";
    TipoVinculo["ESTADO"] = "E";
    TipoVinculo["REDE_TELECONSULTORIA"] = "D";
    TipoVinculo["REDE_TELEMEDICINA"] = "R";
    TipoVinculo["INSTITUICAO"] = "I";
    TipoVinculo["USUARIO"] = "U";
    return TipoVinculo;
}(TipoVinculo_TipoVinculo || {});
/* export default */ const security_TipoVinculo = (TipoVinculo_TipoVinculo);

;// CONCATENATED MODULE: ./src/security/FuncionalidadesMap.ts


var FuncionalidadesMap_Funcionalidade = /*#__PURE__*/ function(Funcionalidade) {
    // Acesso ao módulo console
    Funcionalidade["MODULO"] = "MODULO";
    // Acesso as páginas do módulo console
    Funcionalidade["PAGINA_CREDENCIAIS"] = "PAGINA_CREDENCIAIS";
    Funcionalidade["PAGINA_MODULOS"] = "PAGINA_MODULOS";
    Funcionalidade["PAGINA_PARCEIROS"] = "PAGINA_PARCEIROS";
    return Funcionalidade;
}(FuncionalidadesMap_Funcionalidade || {});
const FuncionalidadesMap = {
    ["MODULO"]: {
        descricao: 'Acesso ao módulo console.',
        permissoes: [
            security_Permissao.CONSOLE
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN
        ]
    },
    ["PAGINA_CREDENCIAIS"]: {
        descricao: 'Acesso a página de credenciais do módulo console.',
        permissoes: [
            security_Permissao.CREDENCIAIS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN
        ]
    },
    ["PAGINA_PARCEIROS"]: {
        descricao: 'Acesso a página de parceiros do STT.',
        permissoes: [
            security_Permissao.PARCEIROS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN
        ]
    },
    ["PAGINA_MODULOS"]: {
        descricao: 'Acesso a página de módulos so STT.',
        permissoes: [
            security_Permissao.MODULOS
        ],
        tipoVinculo: [
            security_TipoVinculo.ADMIN
        ]
    }
};


;// CONCATENATED MODULE: ./src/security/Perfil.ts
const Perfil = {
    ADMIN_PARCEIRO: 'adminParceiro'
};
/* export default */ const security_Perfil = (Perfil);

;// CONCATENATED MODULE: ./src/security/TipoUsuario.ts
var TipoUsuario_TipoUsuario = /*#__PURE__*/ function(TipoUsuario) {
    TipoUsuario[TipoUsuario["ADMIN"] = 0] = "ADMIN";
    TipoUsuario[TipoUsuario["USUARIO_COM_VINCULO"] = 1] = "USUARIO_COM_VINCULO";
    TipoUsuario[TipoUsuario["USUARIO_SEM_VINCULO"] = 2] = "USUARIO_SEM_VINCULO";
    return TipoUsuario;
}(TipoUsuario_TipoUsuario || {});
/* export default */ const security_TipoUsuario = (TipoUsuario_TipoUsuario);

;// CONCATENATED MODULE: ./src/security/Rbac.ts




class Rbac {
    perfis;
    acesso;
    constructor(perfisRBAC){
        this.perfis = perfisRBAC;
    }
    montarAcesso(funcionalidade) {
        return this.montarAcessoPeloPerfis(funcionalidade);
    }
    temPermissao(funcionalidade) {
        const acesso = this.montarAcesso(funcionalidade);
        return acesso.temPermissao || false;
    }
    temPerfil(identificador) {
        var _this_perfis;
        return Boolean((_this_perfis = this.perfis) === null || _this_perfis === void 0 ? void 0 : _this_perfis.some((p)=>p.identificador === identificador));
    }
    ehAdminParceiroRestrito() {
        return this.temPerfil(security_Perfil.ADMIN_PARCEIRO) && !this.temPermissao(FuncionalidadesMap_Funcionalidade.PAGINA_PARCEIROS);
    }
    montarAcessoPeloPerfis(funcionalidade) {
        var _this_perfis, _this_perfis1, _this_perfis2, _this_perfis3, _this_perfis4;
        let acesso = {
            temPermissao: false,
            tipoUsuario: security_TipoUsuario.USUARIO_SEM_VINCULO,
            tipoVinculo: security_TipoVinculo.USUARIO,
            idsEstado: [],
            idsInstituicao: [],
            idsCidade: [],
            estados: [],
            idsRedeTeleconsultoria: []
        };
        // Caso a funcionalidade não exista. Retornar o acesso padrão.
        const funcionalidadeObj = FuncionalidadesMap[funcionalidade];
        if (!funcionalidadeObj) {
            return acesso;
        }
        // 1 - Verificar se é um perfil ADMIN, não precisa concatenar os vínculos, pois tem acesso a tudo. FIND
        const perfilAdm = (_this_perfis = this.perfis) === null || _this_perfis === void 0 ? void 0 : _this_perfis.find((e)=>{
            var // Verificar se é um perfil ADMIN
            _funcionalidadeObj_tipoVinculo, // Verificar se o tipo de vínculo do perfil está na funcionalidade
            _e_permissoes;
            return e.vinculo === 'G' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        });
        if (perfilAdm) return {
            ...acesso,
            temPermissao: true,
            tipoUsuario: security_TipoUsuario.ADMIN,
            tipoVinculo: security_TipoVinculo.ADMIN
        };
        // 2 - Perfis do tipo rede de teleconsultoria. Precisa concatenar os vínculos. FILTER.
        const perfisNivelRedeTeleconsultoria = ((_this_perfis1 = this.perfis) === null || _this_perfis1 === void 0 ? void 0 : _this_perfis1.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'D' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsRedeTeleconsultoria = perfisNivelRedeTeleconsultoria.map((perfil)=>perfil.redesTeleconsultoria.map((redeTeleconsultoria)=>redeTeleconsultoria.id));
        if (arrayIdsRedeTeleconsultoria.length > 0) {
            let idsRedeTeleconsultoria = arrayIdsRedeTeleconsultoria.reduce((a, acc)=>a.concat(acc));
            idsRedeTeleconsultoria = Array.from(new Set(idsRedeTeleconsultoria));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.REDE_TELECONSULTORIA,
                idsRedeTeleconsultoria
            };
            return acesso;
        }
        // 3 - Perfis do tipo estado. Precisa concatenar os vínculos. FILTER.
        const perfisNivelEstado = ((_this_perfis2 = this.perfis) === null || _this_perfis2 === void 0 ? void 0 : _this_perfis2.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'E' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsEstados = perfisNivelEstado.map((perfil)=>perfil.estados.map((estado)=>estado.id));
        const arrayEstados = perfisNivelEstado.map((perfil)=>perfil.estados.map((estado)=>estado.sigla));
        if (arrayIdsEstados.length > 0) {
            let idsEstado = arrayIdsEstados.reduce((a, acc)=>a.concat(acc));
            idsEstado = Array.from(new Set(idsEstado));
            let estados = arrayEstados.reduce((a, acc)=>a.concat(acc));
            estados = Array.from(new Set(estados));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.ESTADO,
                estados,
                idsEstado
            };
            return acesso;
        }
        // 4 - Perfis do tipo municipio. Precisa concatenar os vínculos. FILTER.
        const perfisNivelMunicipio = ((_this_perfis3 = this.perfis) === null || _this_perfis3 === void 0 ? void 0 : _this_perfis3.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'M' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsCidades = perfisNivelMunicipio.map((perfil)=>perfil.municipios.map((municipio)=>municipio.id));
        if (arrayIdsCidades.length > 0) {
            let idsCidade = arrayIdsCidades.reduce((a, acc)=>a.concat(acc));
            idsCidade = Array.from(new Set(idsCidade));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.MUNICIPIO,
                idsCidade
            };
            return acesso;
        }
        // 5 - Perfis do tipo instituição. Precisa concatenar os vínculos. FILTER.
        const perfisNivelInstituicoes = ((_this_perfis4 = this.perfis) === null || _this_perfis4 === void 0 ? void 0 : _this_perfis4.filter((e)=>{
            var _funcionalidadeObj_tipoVinculo, _e_permissoes;
            return e.vinculo === 'I' && ((_funcionalidadeObj_tipoVinculo = funcionalidadeObj.tipoVinculo) === null || _funcionalidadeObj_tipoVinculo === void 0 ? void 0 : _funcionalidadeObj_tipoVinculo.includes(e.vinculo)) && ((_e_permissoes = e.permissoes) === null || _e_permissoes === void 0 ? void 0 : _e_permissoes.find((ei)=>{
                var _funcionalidadeObj_permissoes;
                return (_funcionalidadeObj_permissoes = funcionalidadeObj.permissoes) === null || _funcionalidadeObj_permissoes === void 0 ? void 0 : _funcionalidadeObj_permissoes.includes(ei);
            }));
        })) || [];
        const arrayIdsInstituicoes = perfisNivelInstituicoes.map((perfil)=>perfil.instituicoes.map((instituicao)=>instituicao.id));
        if (arrayIdsInstituicoes.length > 0) {
            let idsInstituicao = arrayIdsInstituicoes.reduce((a, acc)=>a.concat(acc));
            idsInstituicao = Array.from(new Set(idsInstituicao));
            acesso = {
                ...acesso,
                temPermissao: true,
                tipoUsuario: security_TipoUsuario.USUARIO_COM_VINCULO,
                tipoVinculo: security_TipoVinculo.INSTITUICAO,
                idsInstituicao
            };
            return acesso;
        }
        return acesso;
    }
}

;// CONCATENATED MODULE: ./index.ts
// Export all security-related modules







var __webpack_exports__Funcionalidade = __webpack_exports__.DL;
var __webpack_exports__FuncionalidadesMap = __webpack_exports__.mI;
var __webpack_exports__Perfil = __webpack_exports__.Fp;
var __webpack_exports__Permissao = __webpack_exports__.Ud;
var __webpack_exports__Rbac = __webpack_exports__.l6;
var __webpack_exports__TipoUsuario = __webpack_exports__.Ru;
var __webpack_exports__TipoVinculo = __webpack_exports__.b5;
export { __webpack_exports__Funcionalidade as Funcionalidade, __webpack_exports__FuncionalidadesMap as FuncionalidadesMap, __webpack_exports__Perfil as Perfil, __webpack_exports__Permissao as Permissao, __webpack_exports__Rbac as Rbac, __webpack_exports__TipoUsuario as TipoUsuario, __webpack_exports__TipoVinculo as TipoVinculo };
